(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('RuoloDialogController', RuoloDialogController);

    RuoloDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Ruolo', 'RuoloFunzione'];

    function RuoloDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Ruolo, RuoloFunzione) {
        var vm = this;

        vm.ruolo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.ruolofunziones = RuoloFunzione.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ruolo.id !== null) {
                Ruolo.update(vm.ruolo, onSaveSuccess, onSaveError);
            } else {
                Ruolo.save(vm.ruolo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:ruoloUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
